import TomSelect from 'tom-select';
import { computePosition, offset, flip } from '@floating-ui/dom';
import { gsap } from 'gsap';

function handleDropdownOpen() {
  const parent = this.control.parentElement.parentElement;
  const swiperSlide = parent.parentElement.classList.contains('swiper-slide')
    ? parent.parentElement
    : null;
  const placement = parent.dataset.dropdownPlacement || 'bottom-start';
  computePosition(this.control, this.dropdown, {
    middleware: [flip()],
    placement,
  }).then(({ x, y, placement }) => {
    this.control.parentElement.dataset.dropdownPlacement = placement;

    if (swiperSlide) gsap.set(swiperSlide, { zIndex: 2 });

    gsap.set(this.dropdown, {
      left: x,
      top: y,
    });
    gsap.fromTo(
      this.dropdown,
      { y: -5, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 0.3, ease: 'power3.out' },
    );
  });
}

function handleDropdownClose() {
  const parent = this.control.parentElement.parentElement;
  const swiperSlide = parent.parentElement.classList.contains('swiper-slide')
    ? parent.parentElement
    : null;

  gsap.set(swiperSlide, {
    clearProps: 'zIndex',
  });
  gsap.to(this.dropdown, {
    y: -5,
    autoAlpha: 0,
    duration: 0.25,
    ease: 'power3.out',
  });
}

function handlePopupOpen() {
  const placement =
    this.control.parentElement.parentElement.dataset.dropdownPlacement ||
    'bottom-start';
  computePosition(this.control, this.dropdown, {
    middleware: [offset(8), flip()],
    placement,
  }).then(({ x, y, placement }) => {
    this.control.parentElement.dataset.dropdownPlacement = placement;

    gsap.set(this.dropdown, {
      left: x,
      top: y,
    });
    gsap.fromTo(
      this.dropdown,
      { y: 5, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 0.3, ease: 'power3.out' },
    );
  });
}

function handlePopupClose() {
  gsap.to(this.dropdown, {
    y: 5,
    autoAlpha: 0,
    duration: 0.25,
    ease: 'power3.out',
  });
}

const defaultTomSelectSettings = {
  controlInput: null,
  copyClassesToDropdown: false,
  allowEmptyOption: true,
  optionClass: 'select__option',
  itemClass: 'item',
  render: {
    item: (data, escape) => {
      return '<div><span>' + escape(data.text) + '</span></div>';
    },
  },
};

export function initKitSelect(
  selectorOrElement = '.js-kit-select',
  tomSelectSettings = {},
) {
  if (!selectorOrElement) return;

  const parentElement =
    typeof selectorOrElement === 'string'
      ? document.querySelector(selectorOrElement)
      : selectorOrElement;

  const select = parentElement.querySelector('select');
  if (!select) return;

  const options = [
    {
      id: 100,
      title: 'Без крепежа',
      items: [
        {
          id: 200,
          title: 'Название товара',
          article: 'К01',
          qty: 2,
          image: '/assets/images/kit-select/item1.png',
        },
      ],
    },
    {
      id: 101,
      title: 'Комплект №116',
      items: [
        {
          id: 200,
          title: 'Название товара',
          article: 'К01',
          qty: 2,
          image: '/assets/images/kit-select/item1.png',
        },
        {
          id: 201,
          title: 'Название товара',
          article: 'К01',
          qty: 2,
          image: '/assets/images/kit-select/item2.png',
        },
        {
          id: 202,
          title: 'Название товара',
          article: 'К01',
          qty: 2,
          image: '/assets/images/kit-select/item3.png',
        },
      ],
    },
    {
      id: 102,
      title: 'Комплект №117',
      items: [
        {
          id: 200,
          title: 'Название товара',
          article: 'К01',
          qty: 2,
          image: '/assets/images/kit-select/item1.png',
        },
        {
          id: 203,
          title: 'Название товара',
          article: 'К01',
          qty: 2,
          image: '/assets/images/kit-select/item4.png',
        },
        {
          id: 204,
          title: 'Название товара',
          article: 'К01',
          qty: 2,
          image: '/assets/images/kit-select/item5.png',
        },
      ],
    },
  ];

  let settings = {
    ...defaultTomSelectSettings,
    dropdownClass: 'ts-dropdown kit-select__dropdown',
    optionClass: 'kit-select__option',
    valueField: 'id',
    searchField: 'title',
    options,
    items: [100],
    onDropdownOpen: handlePopupOpen,
    onDropdownClose: handlePopupClose,
    render: {
      option: function (data, escape) {
        const items = data.items.map(
          (item) => `
          <li class="kit-select__item">
            <picture class="kit-select__picture">
              <img src="${escape(item.image)}" loading="lazy" alt="" />
            </picture>
            <span class="kit-select__item-title">${escape(item.title)}</span>
            <span class="kit-select__article">Арт. ${escape(item.article)}</span>
            <span class="kit-select__qty">&times;${escape(item.qty)}</span>
          </li>
          `,
        );

        return `
        <div>
         <p class="kit-select__title">${escape(data.title)}</p>
         <ul class="kit-select__list">
          ${items.join('')}
         </ul>
        </div>
        `;
      },
      item: function (data, escape) {
        return '<div>' + escape(data.title) + '</div>';
      },
    },
    ...tomSelectSettings,
  };

  const tomSelect = new TomSelect(select, settings);
  return tomSelect;
}

export function initSelect(parentElement, tomSelectSettings = {}) {
  if (!parentElement) return;

  const select = parentElement.querySelector('select');
  if (!select) return;

  const isDropdown = parentElement.classList.contains(
    'select--has-generic-dropdown',
  );
  const handleDropdownOpenFunc = isDropdown
    ? handleDropdownOpen
    : handlePopupOpen;
  const handleDropdownCloseFunc = isDropdown
    ? handleDropdownClose
    : handlePopupClose;

  let settings = {
    ...defaultTomSelectSettings,
    onDropdownOpen: handleDropdownOpenFunc,
    onDropdownClose: handleDropdownCloseFunc,
    ...tomSelectSettings,
  };

  return new TomSelect(select, settings);
}

export function initSelects(selector = '.js-select') {
  const selects = document.querySelectorAll(selector);
  selects.forEach((select) => initSelect(select));
}
